<template>
	<div class="about-xhorse" ref="about-where">
		<div class="title">
			<i class="x-icon-where"></i><span class="x-tit-con">Address</span>
		</div>
		<div class="content">
			<div class="x-det">
				<div class="det-img"></div>
				<div class="det-info">
					<ul class="where-select">
						<li class="x-active x-flow"
							@click="selectWhere($event,'sz-yy', 'yy-yy')">Shenzhen City Guangdong Province
						</li>
						<li class="x-flow"
							@click="selectWhere($event,'yy-yy', 'sz-yy')">Yuyao City Zhejiang Province
						</li>
					</ul>
					<div class="where-con" style="clear: both">
						<div class="title sz-yy x-show">Shenzhen Xhorse Electronics Co., Ltd.</div>
						<div class="title yy-yy x-hide">Zhejiang Yongyuan Technology Co., Ltd.</div>

						<div class="sz-yy x-show">
							<div class="address">
								<span class="name x-flow">Address&nbsp;：</span>
								<span class="value x-flow">
									<!--Room 2009-2011, Changhong Technology Building, 12th Tech Road South, Nanshan District, Shenzhen City.-->
									Floor 28, Block A, Building NO.6, International Innovation Valley, Nanshan District, Shenzhen City.
								</span>
							</div>
							<ul class="txt">
								<li class="x-flow margin-top-44">
									<span class="name x-flow">Tel：</span>
									<span class="value x-flow">0755-8670 4336</span>
								</li>
								<li class="x-flow margin-top-44">
									<span class="name x-flow">Fax：</span>
									<span class="value x-flow">0755-8670 4336</span>
								</li>
								<li class="x-flow margin-top-44">
									<span class="name x-flow">Zip code：</span>
									<span class="value x-flow">518101</span>
								</li>
								<li class="x-flow margin-top-44">
									<span class="name x-flow">Email：</span>
									<span class="value x-flow">hr@xhorse.com</span>
								</li>
							</ul>
						</div>

						<div class="yy-yy x-hide">
							<div class="address">
								<span class="name x-flow">Address&nbsp;：</span>
								<span class="value x-flow">No.17 Shaodong Road, Yuyao City, Zhejiang Province.</span>
							</div>
							<ul class="txt">
								<li class="x-flow margin-top-44">
									<span class="name x-flow">Tel：</span>
									<span class="value x-flow">0755-8670 4336</span>
								</li>
								<li class="x-flow margin-top-44">
									<span class="name x-flow">Fax：</span>
									<span class="value x-flow">0755-8670 4336</span>
								</li>
								<li class="x-flow margin-top-44">
									<span class="name x-flow">Zip code：</span>
									<span class="value x-flow">518101</span>
								</li>
								<li class="x-flow margin-top-44">
									<span class="name x-flow">Email：</span>
									<span class="value x-flow">hr@xhorse.com</span>
								</li>
							</ul>
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

    export default {
        methods: {
            selectWhere(evt, active, inactive){
                const _this = this;
                const ele = evt.target;
                $(ele).addClass('x-active');
                $(ele).siblings("li").removeClass('x-active');
                $("." + active).removeClass("x-hide").addClass('x-show');
                $("." + inactive).addClass('x-hide').removeClass('x-show');
            }
        }
    }

</script>

<style scoped>

	.address .name, .txt .name {
		font-family: Open Sans;
		color: #3B3A38;
	}

	.about-xhorse {
		background: #FFFFFF;
		min-width: 61.5rem;
		padding-bottom: .75rem;
		overflow: hidden;
		height: 1140px;
	}

	.about-xhorse > .title {
		min-width: 61.5rem;
		margin-left: 3.25rem;
		text-align: left;
		padding-top: 2.75rem;
		padding-bottom: 2.75rem;
		line-height: 2.75rem;
	}

	.about-xhorse > .content {
		min-width: 54.5rem;
		margin-left: 7rem;
	}

	.title > .x-icon-where {
		display: inline-block;
		content: url("../../../assets/resource/icons/ico_we_address.png");
		width: 2.75rem;
		height: 2.75rem;
		position: relative;
		top: .625rem;
		margin-right: 1rem;
	}

	.title > .x-tit-con {
		display: inline-block;
		width: calc(100% - 3.75rem);
		height: 2.75rem;
		font-family: Open Sans;
		font-size: 1.5rem;
		color: #3B3A38;
	}

	.content > .x-det {
		width: 54.5rem;
	}

	.x-det > .det-con {
		width: 100%;
		height: 7.5rem;
		margin-bottom: 2.75rem;
	}

	.det-img {
		width: 100%;
		height: 34.375rem;
		background: url("../../../assets/resource/images/home/image_we_05.png") no-repeat center;
		margin-bottom: 2.75rem;
		background-size: 100% 100%;
	}

	.where-select {
		height: 3.25rem;
		margin-bottom: 2.75rem;
	}

	.where-select > li {
		height: 3.25rem;
		width: 50%;
		line-height: 3.25rem;
		font-family: Open Sans;
		font-size: 1rem;
		color: #2A2E2E;
		cursor: pointer;
	}

	.where-con > .title {
		width: 100%;
		height: 3.25rem;
		text-align: left;
		font-family: Open Sans;
		font-size: 1.125rem;
		color: #2A2E2E;
		letter-spacing: 0;
	}

	.where-con > .txt {
		width: 100%;
	}

	.address {
		width: 100%;
		padding: 0;
	}

	.value {
		width: 80%;
		height: 1.5rem;
		display: block;
		font-family: Open Sans;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		text-align: left;
		line-height: 1.5rem;
	}

	.name {
		width: 10%;
		height: 1.5rem;
		text-align: left;
		display: block;
		font-family: Open Sans;
		font-size: 1rem;
		color: #515555;
		letter-spacing: 0;
		line-height: 1.5rem;
	}

	.txt > li {
		width: 50%;
	}

	.txt > li > .name {
		width: 20%;
		text-align: right;
	}

	.txt > li > .value {
		width: 80%;
		text-align: left;
	}

	.txt > li > .name {
		width: 20%;
		text-align: right;
		white-space: nowrap;
	}

	.margin-top-44 {
		margin-top: 2.75rem;
	}

</style>



// WEBPACK FOOTER //
// src/components/zh-cn/about/about-where.vue